// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__29z8Y","container":"styles_container__2sJyg","title":"styles_title__2UbvJ","wrapper":"styles_wrapper__1GD0Z","answer":"styles_answer__3b8SD"};